<template>
  <div class="c-material-report">
    <ReportFilter ref="filterRef" @change="onQueryAction">
      <ElButton type="primary" @click="onQueryAction" :loading="tableLoading">查询</ElButton>
    </ReportFilter>

    <div class="dimension-filter-row">
      <DimensionCheckboxV2 v-model="selectedDimensions" :dimensions="DIMENSION_OPTIONS" :min-selected="1" />
    </div>

    <div class="table-wrapper">
      <div class="tab-row">
        <div class="image-detail-type-toggle ghost-button-styles">
          <el-radio-group v-model="dimImageDetail" :disabled="tableLoading" @change="onDimImageDetailChange">
            <el-radio-button ghost :label="SUB_MATERIAL">子素材</el-radio-button>
            <el-radio-button ghost label="0">母素材</el-radio-button>
          </el-radio-group>

          <QueryParamsManager
            style="margin-left: 10px"
            ref="queryParamsManagerRef"
            menu-id="M21041"
            :max-conditions="20"
            @select="onConditionSelect"
            @request-save="onSaveConditions"
          />
        </div>

        <div class="extra-slot">
          <el-radio-group class="date-type-radio" v-model="dateType" :disabled="dimImageDetail !== SUB_MATERIAL" @change="handlerDateType">
            <el-radio-button :label="DATE_TYPE.TOTAL">汇总</el-radio-button>
            <el-radio-button :label="DATE_TYPE.DAY">分日</el-radio-button>
            <el-radio-button :label="DATE_TYPE.WEEK">分周</el-radio-button>
            <el-radio-button :label="DATE_TYPE.MONTH">分月</el-radio-button>
          </el-radio-group>

          <div class="date-picker-wrapper">
            <DateRangePicker
              v-if="dateType === DATE_TYPE.DAY || dateType === DATE_TYPE.TOTAL"
              v-model="datetime"
              style="width: 220px"
              :clearable="false"
              :pickerOptions="{ disabledDate }"
              @change="onDateRangeChange"
            ></DateRangePicker>

            <div>
              <dateWeekRange
                v-if="dateType === DATE_TYPE.WEEK"
                v-model="weekRange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始周"
                end-placeholder="结束周"
                :picker-options="weekOptions"
                @change="onDateRangeChange"
                popper-class="week-range"
              >
              </dateWeekRange>
            </div>
            <div>
              <el-date-picker
                v-if="dateType === DATE_TYPE.MONTH"
                v-model="monthRange"
                type="monthrange"
                range-separator="至"
                style="width: 180px"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                :picker-options="{ disabledDate }"
                @change="onDateRangeChange"
              >
              </el-date-picker>
            </div>
          </div>

          <el-dropdown v-if="canEditRemark" class="batch-operation" trigger="click" @command="openRemarkDialog">
            <ElButton :disabled="!selectedRows.length"> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </ElButton>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="remark">编辑备注</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <CustomColumnDropdownBtn
            ref="tableCustomColsRef"
            name="materialAnalysisReportDataCustomColumn"
            menu-id="M21041"
            :extend-id="1"
            :col-list="DEFAULT_COLS"
            :navs="NAVS"
            @change="onCustomColumnChange"
          ></CustomColumnDropdownBtn>

          <ElButton @click="onDownloadDataAction(dimImageDetail)" :loading="exportLoading" style="margin-left: 5px">数据导出</ElButton>
        </div>
      </div>
      <Viewport v-model="tableHeight">
        <ReportTable
          v-loading="tableLoading"
          border
          stripe
          show-summary
          :data="tableList"
          :columns="tableCol"
          :summaries="summaries"
          :dimension="dimImageDetail"
          :show-selection="canEditRemark"
          :height="tableHeight"
          @selection-change="onSelectionChange"
          @sort-change="sortTable"
          @header-dragend="headerDragend"
        >
          <template #control="{ row }">
            <div>
              <div>
                <el-button type="text" @click="handleTableRowAdDailyDetail({ dimImageDetail, dateType, row })"> 分日数据 </el-button>
              </div>
              <div>
                <el-button type="text" v-if="hasAdDataPermission" @click="handleTableRowAdDetail({ dimImageDetail, dateType, row })">
                  计划数据
                </el-button>
              </div>
              <div><el-button type="text" v-if="hasCommentPermission" @click="handleMaterialComments(row)">素材评论</el-button></div>
            </div>
          </template>
        </ReportTable>

        <el-pagination
          :total="total"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          :page-sizes="[20, 50, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="changePageIndex"
          @size-change="changePageSize"
          class="pager"
          background
        />
      </Viewport>
    </div>

    <el-dialog title="编辑备注" :visible.sync="remarkDialogVisible" :close-on-click-modal="false" width="520px">
      <el-input v-model="remark" type="textarea" :rows="7" maxlength="500" show-word-limit placeholder="请输入备注内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <ElButton @click="remarkDialogVisible = false">取消</ElButton>
        <ElButton type="primary" :loading="remarkSaving" @click="saveRemark">确定</ElButton>
      </span>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, nextTick, getCurrentInstance } from 'vue'
import { useRouter, useRoute } from 'vue-router/composables'
import ReportFilter from './components/analysis-report-filter.vue'
import ReportTable from './components/material-analysis-table.vue'
import DateRangePicker from '@/components/date-range-picker/index.vue'
import DimensionCheckboxV2 from '@/components/dimension/index-v2.vue'
import CustomColumnDropdownBtn from '@/components/custom-column-v2/dropdown-btn.vue'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import DEFAULT_COLS, { NAVS } from '../data/material_analysis_report_column.js'
import {
  DATE_TYPE,
  SUB_MATERIAL,
  DIMENSION_OPTIONS,
  useDateFilter,
  useDimensions,
  useColumns,
  useTableData,
  useRemark,
  useExport
} from './hooks/useAnalysisReport'

const router = useRouter()
const route = useRoute()
// Main Component Logic
const { proxy } = getCurrentInstance()
const filterRef = ref(null)
const queryParamsManagerRef = ref(null)
const dimImageDetail = ref(SUB_MATERIAL)
const committedFilterParams = ref({})

// Dimension selection is a draft until the user clicks Query.
const {
  selectedDimensions,
  appliedDimensions,
  commitDimensions,
  getDimensionParams,
  restoreSelectedDimensions,
  omitDimensionParams
} = useDimensions()

// 1. Setup Columns
const { tableCustomColsRef, tableCol, onCustomColumnChange, headerDragend } = useColumns(appliedDimensions)

// 2. Setup Date Filter (Circular dependency with getData resolved by passing getData later or using watch)
// To break circular dependency, we define a wrapper for getData
const triggerGetData = () => {
  refreshData()
}

const { dateType, datetime, weekRange, monthRange, disabledDate, weekOptions, handlerDateType, onDateRangeChange, getDateParams } =
  useDateFilter(triggerGetData)

// 4. Setup Table Data
const {
  tableHeight,
  tableList,
  summaries,
  tableLoading,
  pageIndex,
  pageSize,
  total,
  sort,
  order,
  existParams,
  getData,
  onQueryAction,
  refreshData,
  changePageIndex,
  changePageSize,
  sortTable,
  handleTableRowAdDetail,
  handleTableRowAdDailyDetail,
  handleMaterialComments
} = useTableData(buildQueryParams, proxy, router)

const { selectedRows, remarkDialogVisible, remark, remarkSaving, onSelectionChange, openRemarkDialog, saveRemark } = useRemark(
  tableList,
  proxy
)

// 5. Setup Export
const { exportLoading, onDownloadDataAction } = useExport(existParams, tableCol, filterRef, proxy)

// 6. Navigation & Other Interactions
const access = computed(() => proxy.$store.state.accessAuth)
const hasAdDataPermission = computed(() => access.value.includes('M21073'))
const hasCommentPermission = computed(() => access.value.includes('M21079'))
const canEditRemark = computed(() => appliedDimensions.value.includes('dimMaterial'))

const onSaveConditions = () => {
  nextTick(() => {
    const params = {
      ...(filterRef.value?.queryForm || {}),
      ...getDimensionParams(selectedDimensions.value)
    }
    queryParamsManagerRef.value?.openSaveDialog(params)
  })
}

const onDimImageDetailChange = () => {
  if (dimImageDetail.value !== SUB_MATERIAL) {
    dateType.value = DATE_TYPE.TOTAL
  }
  refreshData()
}

const onConditionSelect = (conditions) => {
  const conditionInfo = JSON.parse(conditions.conditionInfo) || null
  if (conditionInfo) {
    restoreSelectedDimensions(conditionInfo)
    filterRef.value?.setQueryParams(omitDimensionParams(conditionInfo))
  }
}

// 3. Build Query Params
function buildQueryParams(commitQuery = false) {
  const dateParams = getDateParams()
  if (commitQuery || !Object.keys(committedFilterParams.value).length) {
    committedFilterParams.value = filterRef.value?.buildParams() || {}
    commitDimensions()
  }

  return {
    ...committedFilterParams.value,
    ...getDimensionParams(),
    ...dateParams,
    sort: sort.value,
    order: order.value,
    dimImageDetail: dimImageDetail.value === SUB_MATERIAL ? 1 : undefined
  }
}

const hanldeQueryParams = () => {
  const { labelId, beginTime, endTime } = route.query
  if (beginTime) {
    datetime.value = [beginTime, endTime || beginTime]
  }

  if (!labelId) {
    getData(true)
  }
}

// Initialization
onMounted(hanldeQueryParams)
// onActivated(hanldeQueryParams)
</script>
<style lang="scss" scoped>
.c-material-report {
  padding-top: 10px;

  .table-wrapper {
    height: calc(100% - 194px);
  }

  .dimension-filter-row {
    min-height: 36px;
    padding: 2px 10px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ebeef5;
  }

  .batch-operation {
    margin-right: 5px;
  }

  .tab-row {
    margin-bottom: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-tabs {
      flex: 1;
    }

    .extra-slot {
      display: flex;
      align-items: center;
      margin-left: 10px;

      .date-type-radio {
        margin-right: 5px;
      }
      .date-picker-wrapper {
        margin-right: 5px;
      }
    }
  }

  .pager {
    padding: 5px 0;
    text-align: right;
  }
}
</style>
